import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import SafeHTML from '../SafeHTML';
import CustomPropTypes from '../../utils/customPropTypes';
import ButtonLink from '../ButtonLink';
import scrollToElement from 'scroll-to-element';
import style from '../../../scss/components/GenericBanner/Banner';
import ImageBlock from '../ImageBlock';
import hl_logo from '../../../img/hl_logo.png'
import SimpleSlider from './slider';
import slider from '../../../scss/components/GenericBanner/slider';

export default class GenericBanner extends React.Component {
  static ControlTypes = {
    "IntroHeroFood": "banner banner-hero banner-center banner-hero-sm food",
    "IntroHeroProduct": "banner banner-hero banner-center banner-hero-sm product",
    "IntroHero": "banner banner-hero banner-center banner-hero-sm",
    "LeftAlignedHero": "banner banner-left banner-hero banner-mobile-stacked",
    "CenteredAlignedCard": "banner banner-center banner-card hide-desc-mobile",
    "LeftAlignedCard": "banner banner-left banner-card hide-desc-mobile",
    "LeftAlignedPrefooter": "banner banner-left banner-sm banner-pre-footer",
    "CenteredPrefooter": "banner banner-center banner-sm banner-pre-footer",
    "RightAlignedHero": "banner banner-right banner-hero hide-desc-mobile",
    "HeroGridCard": "banner banner-left banner-hero-grid",
    "Error": "error"
  }
  static propTypes = {
    image: CustomPropTypes.Image,
    mobileImage: CustomPropTypes.Image,
    eyebrow: PropTypes.string,
    description: PropTypes.string,
    title: PropTypes.string,
    video: PropTypes.object,
    button: PropTypes.object,
    link: PropTypes.object,
    controlType: PropTypes.string,
    showJumpLink: PropTypes.bool,
    showBackLink: PropTypes.bool,
    image1: CustomPropTypes.Image,
    mobileImage1: CustomPropTypes.Image,
    alt1: PropTypes.string,
    url1: PropTypes.string,
    image2: CustomPropTypes.Image,
    mobileImage2: CustomPropTypes.Image,
    alt2: PropTypes.string,
    url2: PropTypes.string,
    image3: CustomPropTypes.Image,
    mobileImage3: CustomPropTypes.Image,
    alt3: PropTypes.string,
    url3: PropTypes.string,
    image4: CustomPropTypes.Image,
    mobileImage4: CustomPropTypes.Image,
    alt4: PropTypes.string,
    url4: PropTypes.string,
    image5: CustomPropTypes.Image,
    mobileImage5: CustomPropTypes.Image,
    alt5: PropTypes.string,
    url5: PropTypes.string,
  }
  constructor(props) {
    super(props);
    this.mobile = window.matchMedia('(max-width: 768px)'),
      this.desktop = window.matchMedia('(min-width: 769px)');
    this.state = {
      isMobile: false,
    };
    if (this.mobile.matches) this.state.isMobile = true;
    if (this.desktop.matches) this.state.isMobile = false;
  }
  componentDidMount() {
    // console.log(this.props.eyebrow)
    this._isMounted = true;
    this.mobile.addListener((e) => {
      if (e.matches && this._isMounted) {
        this.setState({ isMobile: true });
      }
    });
    this.desktop.addListener((e) => {
      if (e.matches && this._isMounted) this.setState({ isMobile: false });
    })
  }
  componentWillUnmount() {
    this._isMounted = false;
  }
  getBannerImageProp = () => {
    var img = {};
    if (this.state.isMobile && this.props.mobileImage) {
      img.url = this.props.mobileImage.url;
    }
    else if (this.props.image) {
      img.url = this.props.image.url;
    }
    img.title = this.props.eyebrow;
    return img;
  }
  getSliderurls = () => {
    // console.log("inside slider")
    var sliderData = []
    for (let i = 1; i <= 5; i++) {
      let tempObj = {};
      if (eval(`this.props.image${i}`)) {
        if (this.state.isMobile && eval(`this.props.mobileImage${i}`)) {
          tempObj.url = eval(`this.props.mobileImage${i}.url`);
        } else {
          tempObj.url = eval(`this.props.image${i}.url`);
        }
      }
      if (eval(`this.props.alt${i}`)) {
        tempObj.alt = eval(`this.props.alt${i}`);
      }
      if (eval(`this.props.url${i}`)) {
        tempObj.href = eval(`this.props.url${i}`);
      }
      if (Object.keys(tempObj).length !== 0) {
        sliderData.push(tempObj);
      }
    }
    // console.log(sliderData)
    return sliderData
  }
  onButtonClick = (e) => {
    e.preventDefault();
    let el = document.querySelector('.main > section:nth-of-type(2)');
    scrollToElement(el);
  }
  getClassname = (suffix = '') => {
    let cls = this.props.controlType + `${suffix}`;
    if (this.props.className) {
      cls = cls + ` ${this.props.className}${suffix}`
    }
    if (this.props.video)
      cls = cls + " has-video"
    return cls;
  }
  getGoToParentLink = () => {
    if (this.props.showBackLink) {
      var parentPage = document.querySelector('body').getAttribute('parent-page');
      if (parentPage) {
        var [url, title] = parentPage.split(';');
        return <div className="has-back-link">
          <div className="container"><a href={url} className="zindexback btn btn-link-normal btn-back-link">
            <i className="icon icon-prev"></i>&nbsp;{title}
          </a></div>
        </div>
      }
    }
    return null;
  }
  render() {
    return (
      <div>
      {this.props.title == 'Contact Us' && (
        <section className="banner banner-hero-contact banner-center banner-hero-sm ">
          <div className="contact-banner">
            <div className="banner-object">
              <ImageBlock image={this.getBannerImageProp()} imgClassName="object-embed" addWrapper={false} addImageAsBg={true}></ImageBlock>
            </div>
            <div className="banner-container-new">
              <div id={this.props.eyebrow} className="container banner-wrapper-contact">
                <div className="banner-inner-contact">
                  {this.props.eyebrow && <h5 className="hunterlab-title banner-title">
                    {this.props.eyebrow}
                  </h5>
                  }
                  {this.props.title &&
                    <h1 className="banner-main-title">{this.props.title}</h1>
                  }
                  {this.props.header &&
                    <h2>{this.props.header}</h2>
                  }
                  {this.props.description && <div className="banner-desc">
                    <SafeHTML>
                      {this.props.description}
                    </SafeHTML>
                  </div>
                  }
                </div>
                <div class="ui card top">
              <div class="content">
                <div class="description"> <span class="">
                  <p data-block-key="yw99m">We have a support portal that has the answers to your most common support questions! <a href="https://support.hunterlab.com/hc/en-us"
                    target="_blank"><b>Check it out here.</b></a></p><p data-block-key="nawmk">If you don’t find what you need, please <a href="https://support.hunterlab.com/hc/en-us/requests/new"
                      target="_blank"><b>submit</b></a> a support request through our help center or email us at <a href="mailto:support@hunterlab.com">support@hunterlab.com</a></p></span>
                    <a class="col ButtonLink btn btn-outline-contact supportBtn" href="https://support.hunterlab.com/hc/en-us/requests/new"
                      target="blank"><span>Click Here for Support & Accessories</span></a>
                </div>
              </div>
            </div>
              </div>
            </div>
            
          </div>
        </section>
        )}
      {this.props.title == 'Contáctenos' && (
        <section className="banner banner-hero-contact banner-center banner-hero-sm ">
          <div className="contact-banner">
            <div className="banner-object">
              <ImageBlock image={this.getBannerImageProp()} imgClassName="object-embed" addWrapper={false} addImageAsBg={true}></ImageBlock>
            </div>
            <div className="banner-container-new">
              <div id={this.props.eyebrow} className="container banner-wrapper-contact">
                <div className="banner-inner-contact">
                  {this.props.eyebrow && <h5 className="hunterlab-title banner-title">
                    {this.props.eyebrow}
                  </h5>
                  }
                  {this.props.title &&
                    <h1 className="banner-main-title">{this.props.title}</h1>
                  }
                  {this.props.header &&
                    <h2>{this.props.header}</h2>
                  }
                  {this.props.description && <div className="banner-desc">
                    <SafeHTML>
                      {this.props.description}
                    </SafeHTML>
                  </div>
                  }
                </div>
                <div class="ui card top">
              <div class="content">
                <div class="description"> <span class="">
                  <p data-block-key="yw99m">We have a support portal that has the answers to your most common support questions! <a href="https://support.hunterlab.com/hc/en-us"
                    target="_blank"><b>Check it out here.</b></a></p><p data-block-key="nawmk">If you don’t find what you need, please <a href="https://support.hunterlab.com/hc/en-us/requests/new"
                      target="_blank"><b>submit</b></a> a support request through our help center or email us at <a href="mailto:support@hunterlab.com">support@hunterlab.com</a></p></span>
                    <a class="col ButtonLink btn btn-outline-contact supportBtn" href="https://support.hunterlab.com/hc/en-us/requests/new"
                      target="blank"><span>Click Here for Support & Accessories</span></a>
                </div>
              </div>
            </div>
              </div>
            </div>
          </div>
        </section>
        )}
        {this.props.title !== 'Contact Us' && this.props.title !== 'Contáctenos' && (
        <section className={this.getClassname()}>
        <div>
        {this.props.image && <div className="banner-object">
          <ImageBlock image={this.getBannerImageProp()} imgClassName="object-embed" addWrapper={false} addImageAsBg={true}></ImageBlock>
        </div>
        }
        {this.props.video && <div className="banner-object">
          <video width="100%" height="100%" className="object-embed desktop-show" playsInline autoPlay muted loop>
            <source src={this.props.video.url} type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          <div className="logo-container-new mobile-show">
            <img src={hl_logo} className="hl-logo-new" />
          </div>
          <video width="100%" height="100%" className="object-embed mobile-show" playsInline autoPlay muted loop>
            <source src="https://hunterlab-staging.s3.amazonaws.com/media/documents/Mobile_Video_HL.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
        </div>
        }
        {this.props.image1 && <div className="banner-object slider">
          <SimpleSlider sliderData={this.getSliderurls()}></SimpleSlider>
        </div>
        }
        {this.getGoToParentLink()}
        {this.props.image1 &&
          <div className="banner-container-new-slider">
            <div id={this.props.eyebrow} className="container banner-wrapper">
              {this.props.children}
            </div>
          </div>
        }
        {!this.props.image1 &&
          <div className="banner-container-new">
            <div id={this.props.eyebrow} className="container banner-wrapper">
              {!this.props.image1 &&
                <div className="banner-inner">
                  {this.props.eyebrow && <h5 className="hunterlab-title banner-title">
                    {this.props.eyebrow}
                  </h5>
                  }
                  {this.props.title &&
                    <h1 className="banner-main-title">{this.props.title}</h1>
                  }
                  {this.props.header &&
                    <h2>{this.props.header}</h2>
                  }
                  {this.props.description && <div className="banner-desc">
                    <SafeHTML>
                      {this.props.description}
                    </SafeHTML>
                  </div>}
                  {this.props.button && (this.props.button.text && (
                    <ButtonLink className="btn banner-btn" {...this.props.button} />
                  ))}

                  {this.props.link && (this.props.link.text && (
                    <ButtonLink className="btn btn-link banner-btn" {...this.props.link} />
                  ))}
                  {this.props.showJumpLink && <a
                    href="#"
                    className="btn btn-circle btn-scrollToBottom"
                    onClick={this.onButtonClick}>
                    <i className="icon icon-down"></i>
                  </a>}
                </div>
              }
              {this.props.children}
            </div>
          </div>
        }
        </div>
      </section>
  )}
      </div>
    )
  }
}
